import * as actionTypes from "../../actionLabels/index";

export const fetchAuctionBidHistoryData = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_DATA,
    payload: data,
  };
};

export const fetchAuctionBidHistoryDataSuccess = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_SUCCESS,
    payload: data,
  };
};

export const fetchAuctionBidHistoryDataFailure = (error) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_FAILURE,
    payload: error,
  };
};
export const fetchAuctionBidHistoryDataExportSuccess = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_EXPORT_SUCCESS,
    payload: data,
  };
};

export const fetchAuctionBidHistoryDataApiCall = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_API_CALL,
    payload: data,
  };
};

export const fetchAuctionBidHistoryLotWiseData = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA,
    payload: data,
  };
};

export const fetchAuctionBidHistoryLotWiseDataSuccess = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_SUCCESS,
    payload: data,
  };
};

export const fetchAuctionBidHistoryLotWiseDataFailure = (error) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_FAILURE,
    payload: error,
  };
};

export const fetchAuctionBidHistoryLotWiseDataApiCall = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_API_CALL,
    payload: data,
  };
};

export const fetchSearchDropDownForAuctionBidHistory = (data) => {
  return {
    type: actionTypes.FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY,
    payload: data,
  };
};

export const fetchSearchDropDownForAuctionBidHistorySuccess = (data) => {
  return {
    type: actionTypes.FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_SUCCESS,
    payload: data,
  };
};

export const fetchSearchDropDownForAuctionBidHistoryFailure = (data) => {
  return {
    type: actionTypes.FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_FAILURE,
    payload: data,
  };
};
